import OrderPage from "../../features/order/order-page";

export default function Order() {
  return <OrderPage />;
}
